import { render, staticRenderFns } from "./Add-novo-colaborador.vue?vue&type=template&id=1cd05dcb&scoped=true&"
import script from "./Add-novo-colaborador.vue?vue&type=script&lang=js&"
export * from "./Add-novo-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./Add-novo-colaborador.vue?vue&type=style&index=0&id=1cd05dcb&scoped=true&lang=css&"
import style1 from "./Add-novo-colaborador.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd05dcb",
  null
  
)

export default component.exports